import { Accordion } from "./accordion"
import { Body } from "./body"
import { CollectionProducts } from "./collection-products"
import { Header } from "./header"
import { Dropdown } from "./dropdown"
import { FilterDropdown } from "./filter-dropdown"
import { MiniCart } from "./mini-cart"
import { Modal } from "./modal"
import { Product } from "./product"
import { Scrollspy } from "./scrollspy"
import { SectionEditor } from "./section-editor"
import { SectionCollectionList } from "./section-collection-list"
import { SectionCollectionNavigation } from "./section-collection-navigation"
import { SectionFeaturedProducts } from "./section-featured-products"
import { SectionInstagram } from "./section-instagram"
import { SectionMakerCollection } from "./section-maker-collection"
import { SectionNavigationBar } from "./section-navigation-bar"
import { SectionPageNavigation } from "./section-page-navigation"
import { SectionSearch } from "./section-search"
import { SectionStory } from "./section-story"
import { Tabs } from "./tabs"
import { VideoPlayer } from "./video-player"
import { BlogHero } from "./blog-hero"
import { InfiniteScroll } from "./infiniteScroll"
import { BlogQuote } from "./blog-quote"
import { BlogFeaturedStory } from "./blog-featured-story"
import { BlogRecentStories } from "./blog-recent-stories"
import { BlogArticlePreview } from "./blog-article-preview"
import { BlogStoriesPreview } from "./blog-all-stories-preview"
import { BlogCategories } from "./blog-categories"
import { SocialPopup } from "./social-popup"
import { BlogArticleCarousel } from "./blog-article-carousel"
import { CountrySelect } from "./countrySelect"
import { CountryPopup } from "./countryPopup"
import { MarketingConfirmation } from "./marketing-confirmation"
import { SearchPopup } from "./search-popup"
import { ContactCarousel } from "./contact-carousel"

export const componentsDeclarations = {
  accordion: Accordion,
  body: Body,
  blogHero: BlogHero,
  blogQuote: BlogQuote,
  blogFeaturedStory: BlogFeaturedStory,
  blogRecentStories: BlogRecentStories,
  blogArticlePreview: BlogArticlePreview,
  blogStoriesPreview: BlogStoriesPreview,
  blogCategories: BlogCategories,
  blogArticleCarousel: BlogArticleCarousel,
  collectionProducts: CollectionProducts,
  contactCarousel: ContactCarousel,
  header: Header,
  dropdown: Dropdown,
  filterDropdown: FilterDropdown,
  miniCart: MiniCart,
  modal: Modal,
  product: Product,
  scrollspy: Scrollspy,
  sectionEditor: SectionEditor,
  sectionCollectionList: SectionCollectionList,
  sectionCollectionNavigation: SectionCollectionNavigation,
  sectionFeaturedProducts: SectionFeaturedProducts,
  sectionInstagram: SectionInstagram,
  sectionMakerCollection: SectionMakerCollection,
  sectionNavigationBar: SectionNavigationBar,
  sectionPageNavigation: SectionPageNavigation,
  sectionSearch: SectionSearch,
  sectionStory: SectionStory,
  socialPopup: SocialPopup,
  tabs: Tabs,
  videoPlayer: VideoPlayer,
  infiniteScroll: InfiniteScroll,
  countrySelect: CountrySelect,
  countryPopup: CountryPopup,
  marketingConfirmation: MarketingConfirmation,
  searchPopup: SearchPopup,
}
